<template>
    <div>
        <div class="saving" v-if="saving">
            <LoadingSpinner :loading="saving"/>
        </div>
        <div class="row">
            <div class="col-4">
                <EditPanel v-model="template" :selectedPage="page"/>
            </div>
            <div class="col-8">
                <h2>{{ $t("templates.name") }}</h2>
                <input class="form-control mb-5 mt-2" v-model="name">
                <Calculation v-model="template" :edit="true" :create="true" @select-page="updatePage"></Calculation>
                <div class="text-center mt-5">
                    <button class="btn btn-primary" @click="save">Uložit</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Calculation from '@/components/Calculation.vue';
import EditPanel from '@/components/EditPanel.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
export default {
    components: {
        Calculation,
        EditPanel,
        LoadingSpinner
    },
    data() {
        return {
            page: 0,
            name: null,
            template: {
                "pages": [
                    {
                        "structure": [
                        ]
                    }
                ]
            },
            saving: false
        }
    },
    created: function () {
        this.loadData()
    },
    methods: {
        loadData: function () {
            this.loading = true;
            this.$store.getters.api.get("/template/" + this.$route.params.id).then(function (response) {
                this.template = response.data.template;
                this.name = response.data.name;
                this.loading = false;
            }.bind(this))
        },
        save: function () {
            this.saving = true;
            this.$store.getters.api.put("/template/"  + this.$route.params.id + "/edit",
                { "name": this.name, "data": this.template }
            ).then(function () {
                this.saving = false;
            }.bind(this))
        },
        updatePage: function (page) {
            this.page = page;
        }
    }
}
</script>
<style lang="scss">
</style>